import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  DARK_THEME,
  DarkThemeService,
  UIDialogRef,
  UIResponsiveImageModule,
  UIToast,
  UIToastComponent,
  UIToastRef
} from '@irohalab/deneb-ui';
import { Subscription } from 'rxjs';
import { RATING_TEXT } from '../rating/rating.component';
import { Favorite, FavoriteStatus, MainItem } from '@irohalab/mira-sdk-angular';
import { NgClass } from '@angular/common';

@Component({
    selector: 'edit-review-dialog',
    templateUrl: './edit-review-dialog.html',
    imports: [
    UIResponsiveImageModule,
    ReactiveFormsModule,
    NgClass
],
    styleUrls: ['./edit-review-dialog.less']
})
export class EditReviewDialogComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  private toastRef: UIToastRef<UIToastComponent>;

  eFavoriteStatus = FavoriteStatus;

  reviewForm!: FormGroup;

  @Input()
  favorite!: Partial<Favorite>;

  @Input()
  item!: MainItem;

  rating!: number;
  favorite_status!: FavoriteStatus|undefined;
  hoverScore!: number;
  isHovering!: boolean;
  hoveringText = '';
  ratingText = '';
  isSaving = false;

  @HostBinding('class.dark-theme')
  isDarkTheme!: boolean;

  constructor(private _dialogRef: UIDialogRef<EditReviewDialogComponent>,
              private _fb: FormBuilder,
              private _darkThemeService: DarkThemeService,
              toast: UIToast) {
    this.toastRef = toast.makeText();
  }

  onHoverRating(s: number) {
    this.isHovering = s > 0;
    this.hoverScore = s;
    if (!this.isHovering) {
      this.hoveringText = '';
    } else {
      this.hoveringText = RATING_TEXT[s];
    }
  }

  onSelectRating(s: number) {
    this.rating = s;
    this.ratingText = RATING_TEXT[s];
  }

  chooseFavoriteStatus(status: FavoriteStatus) {
    this.favorite_status = status;
  }

  onSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  save(): void {
    if (this.reviewForm.invalid) {
      return;
    }
    this.isSaving = true;
    // console.log(this.favorite);
    if (!this.favorite) {
      this.favorite = {
        reviewComment: this.reviewForm.value.comment,
        rating: this.rating,
        status: this.favorite_status,
        item: this.item
      };
    } else {
      this.favorite.rating = this.rating;
      this.favorite.status = this.favorite_status;
      this.favorite.reviewComment = this.reviewForm.value.comment;
    }
    // console.log(this.item);
    this._dialogRef.close(this.favorite);
  }

  cancel(): void {
    this._dialogRef.close(null);
  }

  ngOnInit(): void {
    this.subscription.add(
      this._darkThemeService.themeChange
        .subscribe(theme => {
          this.isDarkTheme = theme === DARK_THEME;
        })
    );
    this.favorite_status = this.favorite?.status;
    this.rating = this.favorite?.rating ?? 0;
    this.reviewForm = this._fb.group({
      comment: ['', Validators.maxLength(200)]
    });
    if (this.favorite?.reviewComment) {
      this.reviewForm.patchValue({comment: this.favorite.reviewComment});
    }

    if (this.favorite?.rating) {
      this.ratingText = RATING_TEXT[this.favorite.rating];
    }
  }

  ngOnDestroy(): void {
    console.log('destroyed');
    this.subscription.unsubscribe();
  }
}
